import { useState, useEffect } from "react";
import { useParams, Routes, Route } from "react-router";

import {
   Site
} from "../../model/model";

import SessionStore from "../../model/SessionStore";

import SiteLayout from "./SiteLayout";
import ListSiteUsers from "../users/ListSiteUsers";
import ListSiteDevices from "../devices/ListSiteDevices";
import CreateSiteUser from "../users/CreateSiteUser";
import CreateSiteDevice from "../devices/CreateSiteDevice";
import EditSiteUser from "../users/EditSiteUser";
import DeviceLayout from "../devices/DeviceLayout"
import EditSiteApiKey from "../api-keys/EditSiteApiKey"
import CreateSiteApiKey from "../api-keys/CreateSiteApiKey"
import ListSiteApiKeys from "../api-keys/ListSiteApiKeys"
import ListSiteZones from "../zone/ListSiteZones"
import CreateSiteZone from "../zone/CreateSiteZone"
import ZoneLayout from "../zone/ZoneLayout"

function SiteLoader() {
  const [site, setSite] = useState<Site | undefined>(undefined);
  const { siteId } = useParams();

  useEffect(() => {
    const getSite = () => {
      SessionStore.getClient().getSite(siteId!, SessionStore.getBearer()).then((resp) => {
        setSite(resp.data);
      });
    };

    SessionStore.on("change", getSite);

    getSite();

    return () => {
      SessionStore.removeListener("change", getSite);
    };
  }, [siteId]);

  if (site === undefined) {
    return null;
  }

  return (
    <Routes>
      <Route path="/users" element={<ListSiteUsers site={site} />} />
      <Route path="/users/create" element={<CreateSiteUser site={site} />} />
      <Route path="/user/:userId/edit" element={<EditSiteUser site={site} />} />

      <Route path="/devices" element={<ListSiteDevices site={site} />} />
      <Route path="/devices/create" element={<CreateSiteDevice site={site} />} />
      <Route path="/device/:devId" element={<DeviceLayout site={site} />} />
      <Route path="/device/:devId/*" element={<DeviceLayout site={site} />} />

      <Route path="/api-keys" element={<ListSiteApiKeys site={site} />} />
      <Route path="/api-keys/create" element={<CreateSiteApiKey site={site} />} />
      <Route path="/api-key/:apiKeyId/edit" element={<EditSiteApiKey site={site} />} />

      <Route path="/zones" element={<ListSiteZones site={site} />} />
      <Route path="/zones/create" element={<CreateSiteZone site={site} />} />
      <Route path="/zone/:zoneId" element={<ZoneLayout site={site} />} />
      <Route path="/zone/:zoneId/*" element={<ZoneLayout site={site} />} />

      <Route path="/*" element={<SiteLayout site={site} />} />
    </Routes>
  );
}

export default SiteLoader;
